import QRCode from 'qrcode'

// filtros de seleção múltipla viajam repetidos na query: clientId[]=1&clientId[]=2
const listToQuery = (key, values) => {
  if (!Array.isArray(values)) return values ? `&${key}=${encodeURIComponent(values)}` : ''

  return values.map((value) => `&${key}[]=${encodeURIComponent(value)}`).join('')
}

export default (api, resource) => ({

  getAll: async ({ params, token }) => {

    const playerId = params.player ? params.player.id.toString() : ''
    const status = params.filter.status ? params.filter.status.value : ''
    const type = params.filter.type ? params.filter.type.value : ''

    const qsPage = `?page=${params.page}`
    const qsPerPage = `&perPage=${params.perPage}`
    const qsId = `&id=${params.filter.id}`
    const qsStatus = `&status=${status}`
    const qsType = `&type=${type}`
    const qsClientId = listToQuery('clientId', (params.filter.clients || []).map((client) => client.id))
    const qsVendorName = listToQuery('vendorName', (params.filter.vendors || []).map((vendor) => vendor.name))
    const qsValue = `&value=${params.filter.value}`
    const qsBegin = `&dateToBegin=${params.filter.date.begin}`
    const qsEnd = `&dateToEnd=${params.filter.date.end}`
    const qsPlayerId = `&playerId=${playerId}`

    const response = await api.get(`/${resource}${qsPage}${qsPerPage}${qsId}${qsStatus}${qsType}${qsClientId}${qsVendorName}${qsValue}${qsBegin}${qsEnd}${qsPlayerId}`, {
      headers: {
        Authorization: token
      }
    })

    return {
      data: response.data
    }
  },

  getByIdWithTransactionHistories: async ({ id, token }) => {

    const response = await api.get(`/${resource}/${id}`, {
      headers: {
        Authorization: token
      }
    })

    const transaction = response.data.transaction

    // sem qr_code o toDataURL lança e derruba a chamada inteira
    if (transaction.type === 'DEPOSIT' && !transaction.qr_code_image && transaction.qr_code) {
      transaction.qr_code_image = await QRCode.toDataURL(transaction.qr_code)
    }

    return {
      data: response.data
    }
  },


  getSummary: async ({ params, token }) => {

    const status = params.filter.status ? params.filter.status.value : ''
    const type = params.filter.type ? params.filter.type.value : ''

    const qsBegin = `?initialDate=${params.filter.date.begin}`
    const qsEnd = `&finalDate=${params.filter.date.end}`
    const qsStatus = `&transactionStatus=${status}`
    const qsType = `&transactionType=${type}`
    const qsClientId = listToQuery('clientId', (params.filter.clients || []).map((client) => client.id))
    const qsVendorName = listToQuery('vendorName', (params.filter.vendors || []).map((vendor) => vendor.name))

    const response = await api.get(`/summary${qsBegin}${qsEnd}${qsStatus}${qsType}${qsClientId}${qsVendorName}`, {
      headers: {
        Authorization: token
      }
    })

    return {
      data: response.data
    }

  },

  // alteração manual do status pelo painel: aceita apenas PAID ou CANCELED e só pode acontecer
  // uma vez por transação — a segunda tentativa volta 409 do backend
  updateStatusManually: async ({ id, status, observation, token }) => {

    const response = await api.patch(`/${resource}/${id}/status`, {
      status,
      observation
    }, {
      headers: {
        Authorization: token
      }
    })

    return {
      data: response.data
    }
  },

  // reenvio manual da notificação ao cliente
  resendClientNotification: async ({ id, token }) => {

    const response = await api.post(`/${resource}/notifications/${id}/resend`, {}, {
      headers: {
        Authorization: token
      }
    })

    return {
      data: response.data
    }
  },

  // emissão avulsa da notificação: só status de recusa que nunca chegou a ser comunicado
  emitClientNotification: async ({ id, token }) => {

    const response = await api.post(`/${resource}/${id}/client-notifications`, {}, {
      headers: {
        Authorization: token
      }
    })

    return {
      data: response.data
    }
  },

  getMetagratorStatus: async ({ id, token }) => {

    const response = await api.get(`/${resource}/${id}/metagrator-status`, {
      headers: {
        Authorization: token
      }
    })

    return {
      data: response.data
    }
  },

  approveMetagratorWithdraw: async ({ id, action, reason, token }) => {

    const response = await api.post(`/${resource}/${id}/metagrator-approval`, {
      action,
      reason
    }, {
      headers: {
        Authorization: token
      }
    })

    return {
      data: response.data
    }
  },

  createManualTransaction: async ({ type, vendor, pixKeyType, pixKey, expirationDate, value, player, token }) => {

    const response = await api.post(`/${resource}/removal`, {
      type,
      vendorId: vendor.id,
      pixKey,
      pixKeyType: pixKeyType,
      expirationDate,
      amount: value,
      player
    }, {
      headers: {
        Authorization: token
      }
    })

    return {
      data: response.data
    }
  },

})